import { render, staticRenderFns } from "./MainSc.vue?vue&type=template&id=f4b4eb84&scoped=true&"
import script from "./MainSc.vue?vue&type=script&lang=js&"
export * from "./MainSc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b4eb84",
  null
  
)

export default component.exports